
import { useEffect } from "react";

const PrivacyCookiebeleid = () => {
  useEffect(() => {
    // Update SEO meta tags for privacy page
    document.title = "Privacy & Cookiebeleid | VakantieUitzoeken.com";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Lees ons privacy- en cookiebeleid. VakantieUitzoeken.com neemt de bescherming van uw persoonlijke gegevens serieus.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'privacy, cookiebeleid, persoonsgegevens, AVG, GDPR, gegevensbescherming');
    }
  }, []);

  return (
    <div className="max-w-4xl mx-auto prose prose-lg">
      <h1 className="text-3xl md:text-4xl font-bold text-orange-600 mb-6">
        Privacy- en cookiebeleid VakantieUitzoeken.com
      </h1>
      
      <div className="space-y-6 text-gray-700">
        <section>
          <p>
            VakantieUitzoeken.com is eigendom van Y-catcher! (KvK: 89776836)
          </p>
          <p>
            Y-catcher!, gevestigd aan Laboratoriumweg 6A, 1525 RA Westknollendam, is verantwoordelijk voor de verwerking van persoonsgegevens zoals weergegeven in deze privacyverklaring.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">Contactgegevens:</h2>
          <p>
            VakantieUitzoeken.com<br />
            Laboratoriumweg 6A<br />
            1525 RA Westknollendam<br />
            +31 75 6401793<br />
            https://www.vakantieuitzoeken.com/<br />
            administratie@y-catcher.nl
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">Persoonsgegevens die wij verwerken</h2>
          <p>
            Y-catcher! verwerkt uw persoonsgegevens doordat u gebruik maakt van onze diensten en/of omdat u deze zelf aan ons verstrekt.
          </p>
          <p>Hieronder vindt u een overzicht van de persoonsgegevens die wij verwerken:</p>
          <ul>
            <li>Voor- en achternaam</li>
            <li>Adresgegevens (zakelijk)</li>
            <li>Telefoonnummer (zakelijk)</li>
            <li>E-mailadres</li>
          </ul>
          <p>
            Bij het versturen van het contactformulier worden de ingevoerde gegevens gelezen in de beveiligde omgeving van Outlook (Office-365), zodat we contact met je kunnen opnemen.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">Bijzondere en/of gevoelige persoonsgegevens die wij verwerken</h2>
          <p>
            Wij verwerken geen bijzondere of gevoelige persoonsgegevens zoals geboortedata, ISBN-nummers, godsdienst, enzovoort.
          </p>
          <p>
            Y-catcher! verwerkt uw persoonsgegevens voor de volgende doelen: Het versturen van een mail, offerte en/of factuur. Of om telefonisch contact op te nemen.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">Hoe lang we persoonsgegevens bewaren?</h2>
          <p>
            We bewaren deze gegevens in ons klantenbestand zolang dit strikt nodig is. U kunt te allen tijde vragen om verwijdering van deze gegevens via administratie@y-catcher.nl.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">Delen van persoonsgegevens met derden</h2>
          <p>
            Wij delen geen persoonlijke gegevens met derden, tenzij dit noodzakelijk is voor – en na overleg met betrokkene – een bepaalde opdracht.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">Cookies, of vergelijkbare technieken, die wij gebruiken</h2>
          <p>
            VakantieUitzoeken.com gebruikt alleen technische en functionele cookies. En analytische cookies die geen inbreuk maken op uw privacy. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen op uw computer, tablet of smartphone. De cookies die wij gebruiken zijn noodzakelijk voor de technische werking van de website en uw gebruiksgemak. Ze zorgen ervoor dat de website naar behoren werkt en onthouden bijvoorbeeld uw voorkeursinstellingen. Ook kunnen wij hiermee onze website optimaliseren. U kunt zich afmelden voor cookies door uw internetbrowser zo in te stellen dat deze geen cookies meer opslaat. Daarnaast kunt u ook alle informatie die eerder is opgeslagen via de instellingen van uw browser verwijderen.
          </p>
          <p>
            U kunt het gebruik van cookies weigeren, door dit in uw browser uit te schakelen.
          </p>
          <p>
            Op onze website worden links gebruikt die doorverwijzen naar websites van derden. Wij hebben geen inzage in de persoongegevens die u met deze derden deelt, maar deze derden kunnen desgewenst wel door de cookies waarnemen dat u via deze website op hun site bent gekomen (bijvoorbeeld via hun webstatistieken).
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">Gegevens inzien, aanpassen of verwijderen</h2>
          <p>
            U heeft het recht om uw persoonsgegevens in te zien, te corrigeren of te verwijderen. Daarnaast heeft u het recht om uw eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van uw persoonsgegevens door Y-catcher! en heeft u het recht op gegevensoverdraagbaarheid. Dat betekent dat u bij ons een verzoek kunt indienen om de persoonsgegevens die wij van u beschikken in een computerbestand naar u of een ander, door u genoemde organisatie, te sturen.
          </p>
          <p>
            U kunt een verzoek tot inzage, correctie, verwijdering, gegevensoverdraging van uw persoonsgegevens of verzoek tot intrekking van uw toestemming of bezwaar op de verwerking van uw persoonsgegevens sturen naar administratie@y-catcher.nl.
          </p>
          <p>
            Om er zeker van te zijn dat het verzoek tot inzage door u is gedaan, vragen wij u een kopie van uw identiteitsbewijs met het verzoek mee te sturen. Maak in deze kopie uw pasfoto, MRZ (machine readable zone, de strook met nummers onderaan het paspoort), paspoortnummer en Burgerservicenummer (BSN) zwart. Dit ter bescherming van uw privacy. We reageren zo snel mogelijk, maar binnen vier weken, op uw verzoek.
          </p>
          <p>
            Y-catcher! wil u er tevens op wijzen dat u de mogelijkheid heeft om een klacht in te dienen bij de nationale toezichthouder, de Autoriteit Persoonsgegevens. Dat kan via de volgende link: https://autoriteitpersoonsgegevens.nl/nl/contact-met-de-autoriteit-persoonsgegevens/tip-ons
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-3">Hoe wij persoonsgegevens beveiligen</h2>
          <p>
            Y-catcher! neemt de bescherming van uw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als u de indruk heeft dat uw gegevens niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan contact op met onze klantenservice of via administratie@y-catcher.nl
          </p>
          <p>
            Y-catcher! bewaart uw persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor uw gegevens worden verzameld.
          </p>
          <p>
            Y-catcher! verkoopt uw gegevens niet aan derden en verstrekt deze uitsluitend indien dit nodig is voor de uitvoering van onze overeenkomst met u of om te voldoen aan een wettelijke verplichting. Met bedrijven die uw gegevens verwerken in onze opdracht, sluiten wij een bewerkersovereenkomst om te zorgen voor eenzelfde niveau van beveiliging en vertrouwelijkheid van uw gegevens. Y-catcher! blijft verantwoordelijk voor deze verwerkingen.
          </p>
        </section>

        <p className="text-sm text-gray-600 mt-8">
          Laatst bijgewerkt: {new Date().toLocaleDateString('nl-NL')}
        </p>
      </div>
    </div>
  );
};

export default PrivacyCookiebeleid;
